module.exports = __webpack_public_path__ + "static/img/logo-b.8865e6b2.png";